import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ClientDashboard, StaffDashboard } from '@/types/api';

export function useClientDashboard(orgId?: string | null) {
  return useQuery({
    queryKey: ['dashboard', 'client', orgId ?? null],
    queryFn: async () =>
      (
        await api.get<ClientDashboard>('/dashboard/client', {
          params: orgId ? { organization_id: orgId } : undefined,
        })
      ).data,
  });
}

export function useStaffDashboard() {
  return useQuery({
    queryKey: ['dashboard', 'staff'],
    queryFn: async () => (await api.get<StaffDashboard>('/dashboard/staff')).data,
  });
}
